var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-primary cursor-pointer pb-0 mb-0",on:{"click":_vm.handleCustomerNameClick}},[_vm._v(" "+_vm._s(_vm.rowData.full_name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }